module.exports = __webpack_public_path__ + "static/media/lykke04.b37628c4.jpg";